import { WidgetModel, unpack_models } from '@jupyter-widgets/base';
import { MODULE_NAME, MODULE_VERSION } from '../version';
class SeriesModel extends WidgetModel {
    defaults() {
        return {
            ...super.defaults(),
            _model_name: SeriesModel.model_name,
            _model_module: SeriesModel.model_module,
            _model_module_version: SeriesModel.model_module_version,
            series: undefined
        };
    }
    toDict() {
        const dict = {};
        for (const [key, val] of Object.entries(this.attributes)) {
            if (key === 'unknown_attrs') {
                if (val) {
                    for (const [unknown_key, unknown_val] of Object.entries(val)) {
                        dict[unknown_key] = unknown_val;
                    }
                }
                continue;
            }
            if (typeof val === 'string' && val.startsWith('__ipecharts_jsfn__::')) {
                const funcStr = val.replace('__ipecharts_jsfn__::', '');
                const decodedString = atob(funcStr);
                const jsonObject = JSON.parse(decodedString);
                const fn = new Function(...jsonObject);
                dict[key] = fn;
                continue;
            }
            if (val !== undefined && val !== null && !key.startsWith('_')) {
                dict[key] = val;
            }
        }
        return dict;
    }
    initialize(attributes, options) {
        var _a;
        super.initialize(attributes, options);
        if (SeriesModel.updateManager) {
            SeriesModel.updateManager.registerModel(this);
            (_a = this.comm) === null || _a === void 0 ? void 0 : _a.on_close(() => {
                SeriesModel.updateManager.unregisterModel(this);
            });
        }
        this.listenTo(this, 'change', this.valueChanged);
    }
    valueChanged(m) {
        var _a;
        if (m === null || m === void 0 ? void 0 : m.changed) {
            Object.values(m.changed).forEach(it => {
                var _a;
                if (Array.isArray(it)) {
                    it.forEach(subModel => {
                        var _a;
                        if (subModel === null || subModel === void 0 ? void 0 : subModel.model_id) {
                            (_a = SeriesModel.updateManager) === null || _a === void 0 ? void 0 : _a.registerChildModel({
                                child: subModel,
                                parent: m
                            });
                        }
                    });
                }
                else {
                    if (it === null || it === void 0 ? void 0 : it.model_id) {
                        (_a = SeriesModel.updateManager) === null || _a === void 0 ? void 0 : _a.registerChildModel({
                            child: it,
                            parent: m
                        });
                    }
                }
            });
        }
        if (SeriesModel.updateManager) {
            SeriesModel.updateManager.sendUpdateSignal(this);
            (_a = this.comm) === null || _a === void 0 ? void 0 : _a.on_close(() => {
                SeriesModel.updateManager.unregisterModel(this);
            });
        }
    }
}
SeriesModel.serializers = {
    ...WidgetModel.serializers,
    series: { deserialize: unpack_models }
};
SeriesModel.updateManager = null;
SeriesModel.model_name = 'SeriesModel';
SeriesModel.model_module = MODULE_NAME;
SeriesModel.model_module_version = MODULE_VERSION;
export { SeriesModel };
